import {
    Alert,
    AlertDescription,
    AlertTitle,
} from '@shared/components/ui/shadcn/alert';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

// 🎯 Componente de alerta para indicar que se requiere seleccionar una impresora
export const PrinterRequiredAlert = () => {
    const { t } = useTranslation('packingModule');

    return (
        <Alert className="mb-4 border-warning/80 bg-bg-warning items-center flex justify-center gap-4">
            <div>
                <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className="w-5 h-5 !text-warning"
                />
            </div>
            <div className="flex-1">
                <AlertTitle className="text-warning text-base !mb-0">
                    {t('alerts.printerRequired.title')}
                </AlertTitle>
                <AlertDescription>
                    {t('alerts.printerRequired.message')}
                </AlertDescription>
            </div>
        </Alert>
    );
}; 